module.exports = __webpack_public_path__ + "static/media/ips.30a24625.svg";